import { render, staticRenderFns } from "./crumbs.vue?vue&type=template&id=0f415484&scoped=true"
import script from "./crumbs.vue?vue&type=script&lang=js"
export * from "./crumbs.vue?vue&type=script&lang=js"
import style0 from "./crumbs.vue?vue&type=style&index=0&id=0f415484&prod&scoped=true&lang=scss"
import style1 from "./crumbs.vue?vue&type=style&index=1&id=0f415484&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f415484",
  null
  
)

export default component.exports